import type { BackgroundColorModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useSemanticModifierValue } from "@agent-ui/features/modifiers/hooks/useSemanticModifierValue";
import { parseColorValue } from "@agent-ui/features/modifiers/utils/parseComputedValue";
import ColorSelector from "@v2/features/modifiers/base/ColorSelector";
import { useOverridableState } from "replo-runtime/shared/hooks/useOverridableState";

interface BackgroundModifierProps {
  onChange: (modifiers: BackgroundColorModifierValue[]) => void;
}

const BackgroundModifierComponent: React.FC<BackgroundModifierProps> = ({
  onChange,
}) => {
  // NOTE (Derek, 2026-02-05): Use semantic modifier value to support semantic selection
  const extractedColor =
    useSemanticModifierValue({
      semanticExtractor: ({ computedStyles }) => {
        return parseColorValue(computedStyles.backgroundColor) ?? undefined;
      },
    }) ?? null;

  const [currentColor, setCurrentColor] = useOverridableState(
    extractedColor,
    React.useCallback(
      (color: string | null) => {
        const modifier: BackgroundColorModifierValue = {
          type: "backgroundColor",
          value: color,
        };
        onChange([modifier]);
      },
      [onChange],
    ),
  );

  return <ColorSelector value={currentColor} onChange={setCurrentColor} />;
};

export default BackgroundModifierComponent;
